import * as Yup from 'yup';
//utils
import {emailSchema, passwordSchema} from '@/utils/validation';

export type LoginFormValues = {
	email: string;
	password: string;
};

export const initialValues: LoginFormValues = {
	email: '',
	password: '',
};

export const validationSchema = Yup.object().shape({
	email: emailSchema,
	password: passwordSchema,
});
